import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar, Pie } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  Tooltip,
  Legend
);

const DashboardCharts = ({
  type,
  category,
  brands,
  products,
  contacts,
  users,     // ✅ NEW
  inquiry,   // ✅ NEW
}) => {
  const labels = [
    "Categories",
    "Brands",
    "Products",
    "Contacts",
    "Users",
    "Inquiry",
  ];

  const values = [
    category,
    brands,
    products,
    contacts,
    users,
    inquiry,
  ];

  // sober dashboard palette
  const colors = [
    "#6a8098",
    "#709c6a",
    "#c08f5e",
    "#927474",
    "#8b8fa3",  // users
    "#a38b6d",  // inquiry
  ];

  if (type === "bar") {
    return (
      <div style={{ height: "300px" }}>
        <Bar
          data={{
            labels,
            datasets: [
              {
                label: "Total",
                data: values,
                backgroundColor: colors,
                borderRadius: 6,
              },
            ],
          }}
          options={{
            responsive: true,
            maintainAspectRatio: false,
            plugins: { legend: { display: false } },
            scales: {
              y: { beginAtZero: true },
            },
          }}
        />
      </div>
    );
  }

  return (
    <div style={{ height: "300px" }}>
      <Pie
        data={{
          labels,
          datasets: [
            {
              data: values,
              backgroundColor: colors,
            },
          ],
        }}
        options={{
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              position: "bottom",
            },
          },
        }}
      />
    </div>
  );
};

export default DashboardCharts;
